import { fontColor, primaryColor, webFont, textBlack } from '../../config/theme';

const style = {
	searchText: {
		backgroundColor: fontColor,
		color: textBlack,
		fontFamily: webFont,
		height:"48px",
		borderBottomLeftRadius: '40px',
		borderTopLeftRadius: '40px',
		paddingLeft: '10px',
		paddingRight: '10px',
	},
	btnSearch: {
		borderTopRightRadius: '40px',
		borderBottomRightRadius: '40px',
		fontFamily: webFont,
		color: fontColor,
		height:'48px',
		paddingLeft: '10px',
		paddingRight: '10px',
		textTransform: 'none',
		position: 'initial',
		zIndex: 55555
	},
	btnSimple: {
		borderRadius: '50px',
		fontFamily: webFont,
		color: textBlack,
		backgroundColor: fontColor,
		textTransform: 'none',
		marginRight: '10px',
		textAlign: 'center',
		//padding: '8px 30px',
		width: '117px'
	},
	btnSelected: {
		borderRadius: '50px',
		fontFamily: webFont,
		backgroundColor: primaryColor,
		color: fontColor,
		textTransform: 'none',
		marginRight: '10px',
		textAlign: 'center',
		//padding: '8px 30px',
		width: '117px'
	},
	btnSimpleTab: {
		borderRadius: '50px',
		fontFamily: webFont,
		color: textBlack,
		backgroundColor: fontColor,
		textTransform: 'none',
		marginRight: '10px',
		textAlign: 'center',
		//padding: '8px 30px',
		width: '100px'
	},
	btnSelectedTab: {
		borderRadius: '50px',
		fontFamily: webFont,
		backgroundColor: primaryColor,
		color: fontColor,
		textTransform: 'none',
		marginRight: '10px',
		textAlign: 'center',
		//padding: '8px 30px',
		width: '100px'
	},
	txtExplore: {
		color: fontColor,
		fontFamily: webFont,
		marginTop: '7px',
		fontWeight: 600,
		marginRight: '20px',
		fontSize: '16px'
	}
};

export default style;
